import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-common-loader',
	templateUrl: './common-loader.component.html',
    standalone: true,
	styleUrls: ['./common-loader.component.scss'],
})
export class CommonLoaderComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}
